import { useState } from "react";
import { Title, Anchor, Paper } from "@mantine/core";
import Block from "./Block";

export default function App() {
  const [blocks, setBlocks] = useState(['return "Hello, world!"']);
  const [results, setResults] = useState([]);

  const setBlock = (index) => (e) => {
    const nextBlocks = [...blocks];
    nextBlocks[index] = e.target.value;
    setBlocks(nextBlocks);
  };

  const setResult = (index) => (value) => {
    const nextResults = [...results];
    nextResults[index] = value;
    setResults(nextResults);
  };

  const runBlock = (index) => () => {
    try {
      const f = Function(blocks[index]);
      setResult(index)(f());
    } catch (e) {
      setResult(index)(`Error: ${e.message}`);
    }
  };

  const addBlock = (index) => () => {
    const nextBlocks = [...blocks];
    nextBlocks.splice(index + 1, 0, "");
    setBlocks(nextBlocks);
  };

  return (
    <Paper withBorder m="xs" p="xs">
      <Title order={1} align="center" mt="lg" mb="lg">
        A Notebook-style JS Editor
      </Title>
      {blocks.map((block, index) => (
        <Block
          key={index}
          index={index}
          block={block}
          results={results}
          setBlock={setBlock}
          runBlock={runBlock}
          addBlock={addBlock}
        />
      ))}
      <Title order={5} align="center" mb="lg" color="dimmed">
        built by{" "}
        <Anchor href="https://andrueanderson.com" target="_blank">
          Andrue Anderson
        </Anchor>
      </Title>
    </Paper>
  );
}
